import { forwardRef } from "react";
import type { ForwardedRef } from "react";
import { clsx } from "clsx";
import Accessibility from "./assets/accessibility.svg?react";
import AccountSquareOutlined from "./assets/account-square-outlined.svg?react";
import AddPhotoOutlined from "./assets/add-photo-outlined.svg?react";
import AddUser from "./assets/add-user.svg?react";
import AllDone from "./assets/all-done.svg?react";
import AnimationMarker from "./assets/animation-marker.svg?react";
import ArrowBack from "./assets/arrow-back.svg?react";
import ArrowForward from "./assets/arrow-forward.svg?react";
import ArrowUp from "./assets/arrow-up.svg?react";
import AwardOutlined from "./assets/award-outlined.svg?react";
import Award from "./assets/award.svg?react";
import BellFilled from "./assets/bell-filled.svg?react";
import BellRinging from "./assets/bell-ringing.svg?react";
import Bell from "./assets/bell.svg?react";
import BookWithHeart from "./assets/book-with-heart.svg?react";
import Calendar from "./assets/calendar.svg?react";
import CallTalking from "./assets/call-talking.svg?react";
import Camera from "./assets/camera.svg?react";
import CE from "./assets/ce.svg?react";
import Chair from "./assets/chair.svg?react";
import CheckCircle from "./assets/check-circle.svg?react";
import CheckOutlined from "./assets/check-outlined.svg?react";
import Check from "./assets/check.svg?react";
import CheckmarkCloud from "./assets/checkmark-cloud.svg?react";
import ChevronDouble from "./assets/chevron-double.svg?react";
import ChevronDown from "./assets/chevron-down.svg?react";
import ChevronLeft from "./assets/chevron-left.svg?react";
import ChevronRight from "./assets/chevron-right.svg?react";
import ChevronUp from "./assets/chevron-up.svg?react";
import Circle from "./assets/circle.svg?react";
import Clock from "./assets/clock.svg?react";
import CommentVsOutlined from "./assets/comment-vs-outlined.svg?react";
import CopyToClipboard from "./assets/copy-to-clipboard.svg?react";
import Crossfit from "./assets/crossfit.svg?react";
import DeleteOutlined from "./assets/delete-outlined.svg?react";
import Delete from "./assets/delete.svg?react";
import DisappointedEmoji from "./assets/disappointed.svg?react";
import DocumentsOutlined from "./assets/documents-outlined.svg?react";
import Download from "./assets/download.svg?react";
import Edit from "./assets/edit.svg?react";
import EmailOutlined from "./assets/email-outlined.svg?react";
import Email from "./assets/email.svg?react";
import EmptyCalendar from "./assets/empty-calendar.svg?react";
import EmptyDifficultyMap from "./assets/empty-difficulty-map.svg?react";
import Enter from "./assets/enter.svg?react";
import ExpressionlessEmoji from "./assets/expressionless.svg?react";
import EyeOff from "./assets/eye-off.svg?react";
import EyeOn from "./assets/eye-on.svg?react";
import Eye from "./assets/eye.svg?react";
import FaceCam from "./assets/face-cam.svg?react";
import FeedbackSent from "./assets/feedback-sent.svg?react";
import File from "./assets/file.svg?react";
import FilterList from "./assets/filter-list.svg?react";
import Filter from "./assets/filter.svg?react";
import FlagOutlined from "./assets/flag-outlined.svg?react";
import Flag from "./assets/flag.svg?react";
import Flame from "./assets/flame.svg?react";
import FullScreen from "./assets/full-screen.svg?react";
import Globe from "./assets/globe.svg?react";
import HelpButton from "./assets/help-button.svg?react";
import HelpOutlined from "./assets/help-outlined.svg?react";
import Help from "./assets/help.svg?react";
import Helpful from "./assets/helpful.svg?react";
import Home from "./assets/home.svg?react";
import Hospital from "./assets/hospital.svg?react";
import Hot from "./assets/hot.svg?react";
import HourglassRounded from "./assets/hourglass-rounded.svg?react";
import Hourglass from "./assets/hourglass.svg?react";
import InfinityIcon from "./assets/infinity.svg?react";
import InfoCircle from "./assets/info-circle.svg?react";
import InfoOutlined from "./assets/info-outlined.svg?react";
import Info from "./assets/info.svg?react";
import KnowledgeBase from "./assets/knowledge-base.svg?react";
import Like from "./assets/like.svg?react";
import Lock from "./assets/lock.svg?react";
import LogoSquare from "./assets/logo-square.svg?react";
import Logout from "./assets/logout.svg?react";
import Map from "./assets/map.svg?react";
import Medal from "./assets/medal.svg?react";
import MenuHamburger from "./assets/menu-hamburger.svg?react";
import MessageOutline from "./assets/message-outline.svg?react";
import MessagesOutlined from "./assets/messages-outlined.svg?react";
import MicOffOutlined from "./assets/mic-off-outlined.svg?react";
import MicOutlined from "./assets/mic-outlined.svg?react";
import Minus from "./assets/minus.svg?react";
import Moon from "./assets/moon.svg?react";
import MoreHorizontal from "./assets/more-horizontal.svg?react";
import MoreVertical from "./assets/more-vertical.svg?react";
import MotionArrows from "./assets/motion-arrows.svg?react";
import Motion from "./assets/motion.svg?react";
import MoveToTrash from "./assets/move-to-trash.svg?react";
import Music from "./assets/music.svg?react";
import Mute from "./assets/mute.svg?react";
import NewReleaseOutlined from "./assets/new-release-outlined.svg?react";
import OnboardingFlag from "./assets/onboarding-flag.svg?react";
import OpenInNew from "./assets/open-in-new.svg?react";
import Pause from "./assets/pause.svg?react";
import People from "./assets/people.svg?react";
import Person from "./assets/person.svg?react";
import Phone from "./assets/phone.svg?react";
import PhotoFilter from "./assets/photo-filter.svg?react";
import Play from "./assets/play.svg?react";
import PlusOutlined from "./assets/plus-outlined.svg?react";
import Plus from "./assets/plus.svg?react";
import PrescriptionUploadFailed from "./assets/prescription-upload-failed.svg?react";
import ProgressMarker from "./assets/progress-marker.svg?react";
import ProgressPill from "./assets/progress-pill.svg?react";
import ReactionsButton from "./assets/reactions-button.svg?react";
import Refresh from "./assets/refresh.svg?react";
import ReliefEmoji from "./assets/relief.svg?react";
import Restart from "./assets/restart.svg?react";
import Restore from "./assets/restore.svg?react";
import SadEmoji from "./assets/sad.svg?react";
import SafeArea from "./assets/safe-area.svg?react";
import Scissors from "./assets/scissors.svg?react";
import Search from "./assets/search.svg?react";
import Security from "./assets/security.svg?react";
import SettingsOutlined from "./assets/settings-outlined.svg?react";
import Settings from "./assets/settings.svg?react";
import Skip from "./assets/skip.svg?react";
import SmileEmoji from "./assets/smile.svg?react";
import Sort from "./assets/sort.svg?react";
import SoundWaves from "./assets/sound-waves.svg?react";
import Sound from "./assets/sound.svg?react";
import SpeakerMinus from "./assets/speaker-minus.svg?react";
import SpeakerPlus from "./assets/speaker-plus.svg?react";
import SquiggledWarning from "./assets/squiggled-warning.svg?react";
import StarOutline from "./assets/star-outline.svg?react";
import Star from "./assets/star.svg?react";
import Survey from "./assets/survey.svg?react";
import Swap from "./assets/swap.svg?react";
import TableEmpty from "./assets/table-empty.svg?react";
import ThankYou from "./assets/thank-you.svg?react";
import ThreeDots from "./assets/three-dots.svg?react";
import Time0 from "./assets/time-0.svg?react";
import Time20 from "./assets/time-20.svg?react";
import Time30 from "./assets/time-30.svg?react";
import Time40 from "./assets/time-40.svg?react";
import Time from "./assets/time.svg?react";
import Timer from "./assets/timer.svg?react";
import Transfer from "./assets/transfer.svg?react";
import TrendingUp from "./assets/trending-up.svg?react";
import UploadPrescription from "./assets/upload-prescription.svg?react";
import Upload from "./assets/upload.svg?react";
import User from "./assets/user.svg?react";
import VideoCameraOutlined from "./assets/video-camera-outlined.svg?react";
import WarningOutlined from "./assets/warning-outlined.svg?react";
import xCircle from "./assets/x-circle.svg?react";
import XOutline from "./assets/x-outline.svg?react";
import X from "./assets/x.svg?react";
import YogaPose from "./assets/yoga-pose.svg?react";

export const Icons = {
  accountSquareOutlined: AccountSquareOutlined,
  documentsOutlined: DocumentsOutlined,
  openInNew: OpenInNew,
  security: Security,
  infoOutlined: InfoOutlined,
  settingsOutlined: SettingsOutlined,
  warningOutlined: WarningOutlined,
  emailOutlined: EmailOutlined,
  callTalking: CallTalking,
  messagesOutlined: MessagesOutlined,
  medal: Medal,
  bookWithHeart: BookWithHeart,
  survey: Survey,
  map: Map,
  arrowForward: ArrowForward,
  arrowBack: ArrowBack,
  checkmarkCloud: CheckmarkCloud,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  minus: Minus,
  plus: Plus,
  plusOutlined: PlusOutlined,
  emptyDifficultyMap: EmptyDifficultyMap,
  search: Search,
  x: X,
  star: Star,
  starOutline: StarOutline,
  eyeOff: EyeOff,
  eyeOn: EyeOn,
  flame: Flame,
  check: Check,
  filter: Filter,
  chair: Chair,
  bell: Bell,
  file: File,
  upload: Upload,
  skip: Skip,
  email: Email,
  timer: Timer,
  play: Play,
  restart: Restart,
  pause: Pause,
  fullScreen: FullScreen,
  info: Info,
  settings: Settings,
  help: Help,
  helpOutlined: HelpOutlined,
  sound: Sound,
  mute: Mute,
  speakerMinus: SpeakerMinus,
  speakerPlus: SpeakerPlus,
  calendar: Calendar,
  camera: Camera,
  checkOutlined: CheckOutlined,
  crossfit: Crossfit,
  accessibility: Accessibility,
  infinityIcon: InfinityIcon,
  motionArrows: MotionArrows,
  person: Person,
  moon: Moon,
  progressMarker: ProgressMarker,
  progressPill: ProgressPill,
  bellRinging: BellRinging,
  globe: Globe,
  eye: Eye,
  music: Music,
  clock: Clock,
  phone: Phone,
  helpButton: HelpButton,
  hot: Hot,
  award: Award,
  time0: Time0,
  time20: Time20,
  time30: Time30,
  time40: Time40,
  messageOutline: MessageOutline,
  ce: CE,
  time: Time,
  delete: Delete,
  soundWaves: SoundWaves,
  addPhotoOutlined: AddPhotoOutlined,
  commentVsOutlined: CommentVsOutlined,
  videoCameraOutlined: VideoCameraOutlined,
  micOutlined: MicOutlined,
  micOffOutlined: MicOffOutlined,
  moreVertical: MoreVertical,
  arrowUp: ArrowUp,
  photoFilter: PhotoFilter,
  threeDots: ThreeDots,
  bellFilled: BellFilled,
  home: Home,
  people: People,
  logoSquare: LogoSquare,
  logout: Logout,
  user: User,
  addUser: AddUser,
  hospital: Hospital,
  transfer: Transfer,
  deleteOutlined: DeleteOutlined,
  filterList: FilterList,
  sort: Sort,
  xOutline: XOutline,
  tableEmpty: TableEmpty,
  edit: Edit,
  enter: Enter,
  chevronDouble: ChevronDouble,
  download: Download,
  yogaPose: YogaPose,
  flag: Flag,
  hourglass: Hourglass,
  hourglassRounded: HourglassRounded,
  menuHamburger: MenuHamburger,
  moveToTrash: MoveToTrash,
  copyToClipboard: CopyToClipboard,
  xCircle: xCircle,
  circle: Circle,
  prescriptionUploadFailed: PrescriptionUploadFailed,
  uploadPrescription: UploadPrescription,
  lock: Lock,
  disappointedEmoji: DisappointedEmoji,
  expressionlessEmoji: ExpressionlessEmoji,
  reliefEmoji: ReliefEmoji,
  sadEmoji: SadEmoji,
  smileEmoji: SmileEmoji,
  faceCam: FaceCam,
  swap: Swap,
  motion: Motion,
  safeArea: SafeArea,
  scissors: Scissors,
  moreHorizontal: MoreHorizontal,
  restore: Restore,
  emptyCalendar: EmptyCalendar,
  animationMarker: AnimationMarker,
  awardOutlined: AwardOutlined,
  helpful: Helpful,
  like: Like,
  thankYou: ThankYou,
  feedbackSent: FeedbackSent,
  onboardingFlag: OnboardingFlag,
  squiggledWarning: SquiggledWarning,
  newReleaseOutlined: NewReleaseOutlined,
  refresh: Refresh,
  trendingUp: TrendingUp,
  flagOutlined: FlagOutlined,
  knowledgeBase: KnowledgeBase,
  reactionsButton: ReactionsButton,
  allDone: AllDone,
  infoCircle: InfoCircle,
  checkCircle: CheckCircle,
};

export type IconProps = {
  type: keyof typeof Icons;
  className?: string;
  sizeClasses?: string;
  style?: React.CSSProperties;
};

export const Icon = forwardRef(
  ({ type, className, sizeClasses = "w-5 h-5", style }: IconProps, forwardedRef: ForwardedRef<SVGSVGElement>) => {
    const Component = Icons[type];
    return <Component ref={forwardedRef} className={clsx(className, sizeClasses)} style={style} data-icon={type} />;
  },
);
Icon.displayName = "Icon";
